import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import { LanguageProvider } from '../core/language-provider';
import { getCandidatePrivacyPdf } from '../components/CandidatePrivacyModal';
import { Helmet } from 'react-helmet';


export default function PrivacyCandidati() {
    const pdfUrl = getCandidatePrivacyPdf();
    const title = LanguageProvider.get('footerTexts.legal.candidatesPrivacyPolicy');

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>

            <Container fluid='md' className='mt-5 mb-5'>

                <Container fluid className='mt-5 mb-5 text-secondary'>
                    <h2>{title}</h2>

                    <iframe
                        title={title}
                        src={pdfUrl}
                        className='my-4'
                        style={{ width: '100%', height: '80vh', border: 'none' }}
                    />

                    <Link to="/">
                        <Button variant='primary' size={'lg'}>{LanguageProvider.get('defaults.back_to_home')}</Button>
                    </Link>
                </Container>

            </Container>
        </>
    );
};
